import * as Types from '../../../__generated__/schema';

import { ActorTeaserAPIToken, ActorTeaserUser } from './ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from './ActorTeaser.generated';
export type PolicySummary = Pick<
  Types.Policy,
  | 'id'
  | 'description'
  | 'body'
  | 'displayName'
  | 'resourceTypes'
  | 'outputIds'
  | 'runbook'
  | 'reference'
  | 'severity'
  | 'tags'
  | 'createdAt'
  | 'createdByExternal'
  | 'lastModified'
  | 'enabled'
  | 'analysisType'
  | 'managed'
  | 'parentId'
> & {
  createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
  lastModifiedBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
};

export const PolicySummary = gql`
  fragment PolicySummary on Policy {
    id
    description
    body
    displayName
    resourceTypes
    outputIds
    runbook
    reference
    severity
    tags
    createdAt
    createdByExternal
    createdBy {
      ...ActorTeaser
    }
    lastModified
    lastModifiedBy {
      ...ActorTeaser
    }
    enabled
    analysisType
    managed
    parentId
  }
  ${ActorTeaser}
`;
